export const KIBANA_LOGS = {
  EXTERNAL_CALENDAR_READING: "External Calendar Reading",
}
